import React from 'react';
import { Link } from 'react-router-dom';
import Header from './shared/Header';
import Navigation from './shared/Navigation';
import { getRandomColor } from '../utils/colors';
import { useRandomLinkColors } from '../utils/useRandomLinkColors';
const PhotographsPage = () => {
  // Use our custom hook
  useRandomLinkColors();
  return <div className="min-h-screen bg-[#faf9f7] text-[#333333] font-serif" data-id="element-382">
      <Header data-id="element-383" />
      <main className="flex min-h-screen pt-24 px-6" data-id="element-384">
        <div className="flex flex-col md:flex-row w-full max-w-6xl mx-auto" data-id="element-385">
          <div className="w-full md:w-1/4 mb-8 md:mb-0" data-id="element-386">
            <Navigation data-id="element-387" />
          </div>
          <div className="w-full md:w-3/4 md:pl-8" data-id="element-388">
            <div className="max-w-2xl" data-id="element-389">
              <ul className="list-none leading-tight" data-id="element-390">
                <li className="mb-[0.2rem]" data-id="element-391">
                  <Link to="/motherhood-story" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-392">
                    Motherhood Story (<em data-id="element-393">The Fourth Magazine</em>, 2026)
                  </Link>
                </li>
                <li className="mb-[0.2rem]" data-id="element-394">
                  <Link to="/madonna-child" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-395">
                    Madonna & Child (<em data-id="element-396">Badlon Magazine</em>, 2025)
                  </Link>
                </li>
                <li className="mb-[0.2rem]" data-id="element-397">
                  <Link to="/body-not-thing" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-398">
                    The Body Is Not A Thing (2020 to 2024)
                  </Link>
                </li>
                <li className="mb-[0.2rem]" data-id="element-399">
                  <Link to="/promise-never-forget" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-400">
                    I Promise I'll Never Forget (2018 to 2021)
                  </Link>
                </li>
                <li className="mb-6" data-id="element-401">
                  <Link to="/anchor" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-402">
                    Anchor (2015)
                  </Link>
                </li>
                <li data-id="element-403">
                  <Link to="/notes" className="transition-colors duration-200" onMouseEnter={e => {
                  e.currentTarget.style.color = getRandomColor();
                }} onMouseLeave={e => {
                  e.currentTarget.style.color = '#333333';
                }} data-id="element-404">
                    Field Notes (Ongoing)
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
    </div>;
};
export default PhotographsPage;